<!-- ref: https://bezkoder.com/jwt-vue-vuex-authentication/ -->
<!-- ref: https://blog.sqreen.com/authentication-best-practices-vue/ -->
<!-- ref: https://codepen.io/jcoulterdesign/details/azepmX -->
<template>
  <div :class="$style.login_page" class="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center">
    <div :class="[$style.login, {[$style.test]: authenticating2fa}]">
      <div class="pb-8 text-left text-md text-gray-400"><span>{{loginHeader}}</span></div>
      <div v-if="authenticating" class='absolute left-0 py-3 flex flex-row items-center bg-gray-700 border-b border-t border-gray-500 w-full'>
        <p class="mx-4 text-sm text-gray-100 uppercase">Authenticating...</p>
        <img class="animate-ping" src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/217233/puff.svg'>
      </div>
      <div v-else-if="!loginSucess" :class="$style.login_fields">
        <div :class="$style.field_row" class="text-base text-gray-200">
					<v-icon color='grey'>person</v-icon>
          <input required v-model="username" type="text" placeholder="Username" autofocus>
            <div :class='$style.validation'>
              <img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/217233/tick.png'>
            </div>
					</input>
        </div>
        <div :class="$style.field_row" class="text-base text-gray-200">
					<v-icon color='grey'>lock</v-icon>
          <input required v-model="password" type="password" placeholder="Password" v-on:keyup.enter="login"/>
        </div>
        <div v-if="!authenticating" class="relative left-0 w-auto right-0 mx-5 mt-6">
          <input
            class="py-2 px-4 border-solid border-2 border-orange-500 rounded-lg text-base transition-colors duration-500"
            :class="[enableButton ? 'bg-orange-500 text-white cursor-pointer' : 'bg-transparent text-orange-400']"
            type="submit"
            value='Login'
            @click="login" v-on:keyup.enter="login" />
					<div class="float-right mt-3 text-xs text-gray-300 hover:text-gray-900 hover:bg-gray-400">
						<a href='#'>Forgotten password?</a>
					</div>
          <div class="py-4 text-sm text-gray-300">{{message}}</div>
          <div class="py-2 text-xs text-center text-gray-300">version 1.1.5</div>
        </div>
      </div>
      <div v-else-if="!authenticating" class="absolute left-0">
        <div class="relative border-b border-t border-gray-600">
          <input v-model="userToken"
            ref="totp"
            type="text"
            maxlength="6"
            class="outline-none w-full h-12 px-10 bg-gray-700 text-2xl text-gray-100 tracking-widest"/>
        </div>
        <div class="relativeleft-0 w-full h-12 px-4 mt-4">
          <span v-if="userToken.length < 6" class="text-sm text-gray-400">Please enter the code from your Authenticator app</span>
          <span v-else class="text-sm text-gray-400">{{message}}</span>
        </div>
        <div class="relativeleft-0 w-full px-4 mt-6">
          <a href="javascript:" @click.prevent="launchSetup" class="text-sm text-orange-400">
            Click here to set up the Authenticator app on your mobile
          </a>
        </div>
      </div>
			<div :class='$style.success'>
				<h2>Authentication Success</h2>
			<p>Welcome back</p>
			</div>
			<div :class='$style.disclaimer'>
				<!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce semper laoreet placerat. Nullam semper auctor justo, rutrum posuere odio vulputate nec.</p> -->
			</div>
    </div>
    <modal v-model="setup">
      <h2 class="text-gray-900 text-xl my-4">Setting up Google Authenticator on your mobile</h2>
        <ul class="list-disc list-inside leading-relaxed">
          <li>If you don't already have the app installed, install Google's Authenticator app on your phone.</li>
          <li>Open the Authenticator app on your phone and tap +  or 'begin setup'</li>
          <li>Select Scan barcode and scan the QR code below</li>
        </ul>
        <div v-if="qrCode" class="w-full pb-2"><img class="mx-auto" :src="qrCode" /></div>
        <h4 class="py-2">If you are unable to scan the QR code...</h4>
        <ul v-if="qrSecret" class="list-disc list-inside leading-relaxed">
          <li>In the Authenticator app, select the 'Manual entry' option for adding an account</li>
          <li>For Account enter: Participant Communicator</li>
          <li>For Key enter: {{spacedSecret}}</li>
        </ul>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/Modal.vue'
export default {
  data () {
    return {
      authenticating: false,
      authenticating2fa: false,
      loginSucess: false,
      message: '',
      password: '',
      qrCode: false,
      qrSecret: false,
      setup: false,
      username: '',
      userToken: ''
    }
  },
  components: { Modal },
  computed: {
    enableButton: function () {
      return this.username.length > 0 && this.password.length > 0
    },
    loggedIn () {
      return this.$store.state.auth.status.loggedIn
    },
    loginHeader () {
      return this.loginSucess ? 'Two Factor Authentication' : 'Sign in'
    },
    spacedSecret () {
      return this.qrSecret.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ')
    }
  },
  watch: {
    'userToken': 'onInputChange'
  },
  methods: {
    // When the 2FA setup modal is launched
    async launchSetup () {
      this.setup = true
      // get the QR code
      const results = await this.axios.get(
        `${process.env.VUE_APP_API_BASEURL}/user/${this.$store.state.init.org.identifier}.${this.$store.state.auth.user.username}/qrcode`
        // { headers: `Authorization Bearer ${this.$auth.token()}` },
      ).catch((err) => {
        if (err) console.log(err)
        console.log(results)
      })
      this.qrCode = results.data.qrImg
      this.qrSecret = results.data.secretKey
    },
    async login () {
      this.authenticating = true
      try {
        // give the animation time to do its thing
        setTimeout(() => {
          this.authenticating = false
        }, 900)
        const authResult = await this.$store.dispatch('auth/login', { username: this.username, password: this.password, org: this.$store.state.init.org.identifier })
        if (authResult) {
          this.loginSucess = true
          this.$nextTick(() => {
            console.log(this.$refs.totp)
            const totpInput = this.$refs.totp
            totpInput.focus()
          })
        }
      } catch (err) {
        if (err.status === 401) this.message = 'Incorrect username or password'
        else this.message = (err.status && err.data) || err.message || err.toString()
      }
    },
    // Two Factor Authentication Login
    async onInputChange () {
      this.userToken = this.userToken.replace(/\s/g, '')
      if (this.userToken.length === 6) {
        this.authenticating2fa = true
        console.log('sending userToken')
        try {
          const authResult = await this.$store.dispatch('auth/totpLogin', { ...this.$store.state.auth.user, userToken: this.userToken })
          if (authResult) {
            console.log('2FA auth success')
            setTimeout(() => {
              this.$router.push({ name: 'home', params: { orgName: this.$route.params.orgName } })
            }, 600)
          } else {
            this.authenticating2fa = false
            this.message = 'Authenticator code not valid'
          }
        } catch (error) {
          this.authenticating2fa = false
          this.error = `Error ${error.response.status}: ${error.response.data}`
        };
      }
    }
  },
  created () {
    if (this.loggedIn) this.$router.push({ name: 'home', params: { orgName: this.$route.params.orgName } })
  }
}

</script>
<style module>
.login_page {
	-webkit-perspective: 800px;
          perspective: 800px;
  height: 100vh;
  margin: 0;
  overflow: hidden;
  font-family: 'Gudea', sans-serif;
  background: #EA5C54;
  /* Old browsers */
  /* FF3.6+ */
  /* Chrome10+,Safari5.1+ */
  /* Opera 11.10+ */
  /* IE11+ */
  background: linear-gradient(135deg, rgb(237, 244, 247) 0%, rgb(230, 232, 240) 100%);
  /* W3C */
}
.login {
  opacity: 1;
  top: 20px;
  -webkit-transition-timing-function: cubic-bezier(0.68, -0.25, 0.265, .85);
  transition-property:transform,opacity,box-shadow,top,left;
  transition-duration:.5s;
	-webkit-transform-origin: 161px 100%;
          transform-origin: 161px 100%;
  -webkit-transform: rotateX(0deg);
          transform: rotateX(0deg);
  position:relative;
  width:252px;
  border-top: 2px solid rgb(42, 45, 216);
  height:400px;
  position:absolute;
  left:0;
  right:0;
  margin:auto;
  top:0;
  bottom:0;
  padding:100px 40px 40px 40px;
  background: #35394a; /* Old browsers */
  background: -moz-linear-gradient(45deg,  #35394a 0%, #1f222e 100%); /* FF3.6+ */
  background: -webkit-gradient(linear, left bottom, right top, color-stop(0%,#35394a), color-stop(100%,#1f222e)); /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(45deg,  #35394a 0%,#1f222e 100%); /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(45deg,  #35394a 0%,#1f222e 100%); /* Opera 11.10+ */
  background: -ms-linear-gradient(45deg,  #35394a 0%,#1f222e 100%); /* IE10+ */
  background: linear-gradient(45deg,  #35394a 0%,#1f222e 100%); /* W3C */
}
.login_fields {
  height: 208px;
  position: absolute;
  left: 0;
}
.login_fields i {
  position: absolute;
  z-index: 1;
  left: 36px;
  top: 8px;
  opacity: .5;
}
.field_row{
  position: relative;
}
.field_row input {
  width: 250px;
  margin-top:-2px;
  background: rgb(50, 54, 74);
  left: 0;
  padding: 10px 65px;
  border-top: 2px solid rgb(57, 61, 82);
  border-bottom: 2px solid rgb(57, 61, 82);
  border-right: none;
  border-left: none;
  outline: none;
  font-family: 'Gudea', sans-serif;
  box-shadow: none;
}
.validation {
	position: absolute;
  z-index: 1;
  right: 10px;
  top: 6px;
  opacity: 0;
}

.success {
	display:none;
  color: rgb(213, 216, 226);
}
.disclaimer {
	position: absolute;
  bottom: 20px;
  left: 35px;
  width: 250px;
}
.test {
  box-shadow: 0px 20px 30px 3px rgba(0, 0, 0, 0.55);
  pointer-events: none;
  top: -100px !important;
  -webkit-transform: rotateX(70deg) scale(0.8) !important;
          transform: rotateX(70deg) scale(0.8) !important;
  opacity: .6 !important;
  -webkit-filter: blur(1px);
  filter: blur(1px);
}
</style>
